import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { getToken } from '@/api/client';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/RegisterView.vue'),
    meta: { public: true },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPasswordView.vue'),
    meta: { public: true },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/ResetPasswordView.vue'),
    meta: { public: true },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/DashboardView.vue'),
  },
  {
    path: '/monitors',
    name: 'monitors',
    component: () => import('@/views/MonitorListView.vue'),
  },
  {
    path: '/monitors/new',
    name: 'new-monitor',
    component: () => import('@/views/NewMonitorView.vue'),
  },
  {
    path: '/monitors/:id/edit',
    name: 'edit-monitor',
    component: () => import('@/views/NewMonitorView.vue'),
    props: true,
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/NotificationsView.vue'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/SettingsView.vue'),
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/AdminView.vue'),
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 全局前置守卫：未登录跳转到 /login
// 页面刷新后 Pinia state 会重置，如果有 token 则先恢复用户信息
router.beforeEach(async (to, _from, next) => {
  const auth = useAuthStore();
  if (to.meta.public) {
    next();
    return;
  }
  // 有 token 但 user 为 null（页面刷新场景），先恢复登录状态
  if (getToken() && !auth.user) {
    await auth.fetchMe();
  }
  if (!auth.isAuthenticated) {
    next({ name: 'login' });
    return;
  }
  next();
});
